import React, { Component } from 'react';
import applicationRouter from '~/hoc/applicationRouter'
import { inject, observer } from 'mobx-react';

import TimelogsList from './TimelogsList';
import withLocalization from '../../../hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import { confirmAlert } from 'react-confirm-alert';
class TimelogsPage extends Component {
    async onAdd(openPreviousTimelogModal) {
        const { t, router, commonStore } = this.props;
        const navigateToCurrent = () => router.navigate('/admin/timelogs/add');

        if (!commonStore.isUserLoggedIn) {
            return navigateToCurrent();
        }
        const navigateToCurrentStartedTimelog = async () => {
            const status = await this.props.timelogStore.getCurrentDraftOrSkip('', '', true);
            if (status && status.timelog && status.timelog.id) {
                return router.navigate(`/admin/timelogs/${status.timelog.id}`, { state: { timelogs: status.timelog.id, page: 0 } });
            }
        }

        confirmAlert({
            message: t('Would you like to include past Timesheet data, or continue with the current data?'),
            buttons: [
                {
                    label: t('Past Timesheet'),
                    onClick: () => typeof openPreviousTimelogModal === 'function' && openPreviousTimelogModal(),
                },
                {
                    label: t('Current Timesheet'),
                    onClick: navigateToCurrentStartedTimelog,
                },
            ],
        });
    }

    componentWillMount() {
        const params = new URLSearchParams(this.props.router.location.search);
        const filterByStatus = params.get('status');
        this.props.timelogStore.setFilter('status', filterByStatus || null);
        this.props.timelogStore.onFilter();
    }
    render() {
        return (
            <TimelogsList
                onAdd={(openPreviousModal) => this.onAdd(openPreviousModal)}
            />
        );
    }
}
export default inject('authStore', 'timelogStore', 'commonStore')(applicationRouter(withLocalization(withRemoveDialog(observer(TimelogsPage)))));
